var postal = require("common/PubSub");

module.exports = function() {
    this.handle = function(jqXHR) {
        if (jqXHR.status === 400) {
            postal.channel("LogonController").publish("show-error", {message : $.t("web::logon.timeout.message")});
        } else if (jqXHR.status === 403) {
            postal.channel("LogonController").publish("show-error", {message : $.t("common::error.badClientCert.message", {0 : window.location.hostname}), noReturn : true});
        } else {
            postal.channel("LogonController").publish("show-error", {message : $.t("common::api.failure.message")});
        }
    };
};